import React, { useEffect, useRef, useState } from "react";
import CustomInput from "../../shared/utils/Input";
import CustomButton from "../../shared/utils/Button";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import {
  Alert,
  Chip,
  CircularProgress,
  FormHelperText,
  Grid,
  IconButton,
  Snackbar,
  Stack,
  TextField,
  Tooltip,
  MenuItem,
  Checkbox,
  Select,
  FormControl,
} from "@mui/material";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import {
  AuditIcon,
  Cross,
  Delivery,
  InstalliationIcons,
  Recce,
  Search,
  Trash,
  UploadRfpIcon,
  ViewIcon,
} from "../../shared/assets/icons";
import axios from "axios";
import Manufacturing from "../assets/icons/Manufacturing";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import zIndex from "@mui/material/styles/zIndex";

const SeriveNeeded = [
  { name: "Recce", icon: <Recce size="16" color="var(--primary-color)" /> },
  {
    name: "Manufacturing",
    icon: <Manufacturing size="16" color="var(--primary-color)" />,
  },
  {
    name: "Delivery",
    icon: <Delivery size="16" color="var(--primary-color)" />,
  },
  {
    name: "Installation",
    icon: <InstalliationIcons size="16" color="var(--primary-color)" />,
  },
  { name: "Audit", icon: <AuditIcon size="16" color="var(--primary-color)" /> },
];

const ClientRFPModal = ({
  selectedCampaign,
  adminPortalView,
  setRfpGenerate,
}) => {
  const [service, setService] = React.useState([]);

  const fileInputRef = useRef(null);
  const containerRef = useRef(null);
  const [SelectedCampaignDetails, SetSelectedCampaignDetails] = useState(null);
  const clientId = localStorage.getItem("clientId");
  const serverURL = process.env.REACT_APP_URL;
  const { id } = useParams();
  const operation = id;
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    campaignName: selectedCampaign?.campaignName || "",
    emailAddress: selectedCampaign?.emailAddress || "",
    campaignOwnerName: selectedCampaign?.campaignOwnerName || "",
    description: selectedCampaign?.description || "",
    startDate: selectedCampaign?.startDate || null,
    endDate: selectedCampaign?.endDate || null,
    teamMembers: selectedCampaign?.teamMembers
      ? selectedCampaign.teamMembers.map((member) => ({
          emailAddress: member.emailAddress,
          id: member._id, // Store the member ID for API requests
        }))
      : [],
    phoneNumber: selectedCampaign?.phoneNumber || null,

    servicesNeeded: selectedCampaign?.servicesNeeded || "",
    document: selectedCampaign?.rfpDocument || [],
    addedBy: adminPortalView ? null : clientId,
  });
  const [team, setTeam] = useState([]);
  const [teamMember, setTeamMember] = useState("");
  const [userDomain, setUserDomain] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [teamError, setteamError] = useState(false);

  const [errors, setErrors] = useState({});
  const [documentUrl, setdocumentUrl] = useState("");
  const [saveButtonClicked, setSaveButtonClicked] = useState(false);
  const [isphoneNumber, setPhoneNumber] = useState(null);
  const [isEmail, setIsEmail] = useState("");
  const [isName, setIsName] = useState("");
  const [organizationName, setOrganizationName] = useState("");

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const fetchClientDetails = async () => {
    try {
      const clientID = localStorage.getItem("clientId");

      if (!clientID) {
        console.warn("No client ID found in localStorage.");
        return;
      }

      const response = await axios.get(
        `${serverURL}/client/dashboard/${clientID}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      console.log(response.data);
      if (response.data.success) {
        // do something with response.data.data

        // setEmail(response?.data?.data?.emailAddress
        // );
        // setName(response?.data?.data?.name
        // );
        // setPhoneNumber(response?.data?.data?.phoneNumber
        // );

        setOrganizationName(
          response?.data?.organizationData?.organizationId?.name
        );
        fetchAllTeamMembers(
          response?.data?.organizationData?.organizationId?.name
        );
      }
    } catch (error) {
      console.error("Error fetching client details:", error);
    }
  };

  const fetchAllTeamMembers = async (organizationName) => {
    try {
      const response = await axios.get(
        `${serverURL}/client/dashboard?organizationName=${organizationName}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      console.log(response.data.data);
      setTeam(response.data.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (id) {
      getSelectedCampaigndetails(operation);
    } else {
      fetchClientDetails();
    }
  }, []);

  const restrictedDomains = ["gmail", "yahoo", "hotmail"];

  const getSelectedCampaigndetails = async (id) => {
    try {
      const response = await axios.get(
        `${serverURL}/requestForProposal/viewRfp/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (response.data.success === true) {
        console.log(response.data.data);
        // SetSelectedCampaignDetails(response.data.data);
        const campaignData = response.data.data;
        SetSelectedCampaignDetails(campaignData);

        setFormData({
          campaignName: campaignData.campaignName || "",
          emailAddress: campaignData.campaignOwnerId.emailAddress || "",
          campaignOwnerName: campaignData.campaignOwnerId.name || "",
          description: campaignData.description || "",
          startDate: campaignData.startDate
            ? dayjs(campaignData.startDate)
            : null,
          endDate: campaignData.endDate ? dayjs(campaignData.endDate) : null,
          teamMembers: campaignData?.teamMembers
            ? campaignData.teamMembers.map((member) => ({
                emailAddress: member.emailAddress,
                id: member._id, // Store the member ID for API requests
              }))
            : [],
          servicesNeeded: campaignData.servicesNeeded || "",
          document: campaignData?.rfpDocument || [],
        });
        setdocumentUrl(campaignData?.rfpDocument);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    let objectUrl;
    if (formData.document instanceof File) {
      objectUrl = URL.createObjectURL(formData.document);
      setdocumentUrl(objectUrl);
    } else {
      setdocumentUrl(formData.document);
    }

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [formData.document]);

  // useEffects-----------------------------------------------------------------
  useEffect(() => {
    const userMailDomain = localStorage.getItem("email");
    console.log(userMailDomain);
    setFormData((prev) => ({ ...prev, emailAddress: userMailDomain }));
    const CampaignOwnerName = localStorage.getItem("name");
    setIsName(CampaignOwnerName);
    setFormData((prev) => ({
      ...prev,
      campaignOwnerName: CampaignOwnerName,
    }));

    setIsEmail(userMailDomain);
    const phoneNumber = localStorage.getItem("phoneNumber");

    setFormData((prev) => ({
      ...prev,
      phoneNumber: phoneNumber,
    }));
    setPhoneNumber(phoneNumber);
    const name = localStorage.getItem("name");
    const user_Domain = userMailDomain.split("@")[1];
    setUserDomain(user_Domain);

    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }

    return () => {
      setFormData({
        campaignName: "",
        emailAddress: "",
        campaignOwnerName: "",
        description: "",
        startDate: null,
        endDate: null,
        teamMembers: [],
        servicesNeeded: "",
        document: "",
      });
    };
  }, [selectedCampaign]); // Include adminPortalView in dependencies

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    if (files.length === 0) return;

    // ❌ Prevent upload if existing document field already has 4 files
    if ((formData.document?.length || 0) >= 4) {
      setErrors((prev) => ({
        ...prev,
        document: "Maximum of 4 documents allowed.",
      }));
      return;
    }

    // ✅ Prevent upload if selected files exceed 4 in one go
    if (files.length > 4) {
      setSnackbar({
        open: true,
        message: "You can only upload up to 4 files at a time.",
        severity: "error",
      });
      return;
    }

    setUploadLoading(true);

    const allowedExtensions = [
      "pdf",
      "xls",
      "xlsx",
      "doc",
      "docx",
      "png",
      "jpg",
      "jpeg",
    ];
    const formDataNew = new FormData();
    let validFiles = [];

    for (let file of files) {
      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        alert(`Invalid file type: ${file.name}. Please upload a valid file.`);
        continue;
      }

      if (file.size > 2 * 1024 * 1024) {
        setSnackbar({
          open: true,
          message: `File too large: ${file.name} (max size: 2MB)`,
          severity: "error",
        });
        continue;
      }

      formDataNew.append("files", file);
      validFiles.push(file);
    }

    // Stop if no valid files
    if (validFiles.length === 0) {
      setUploadLoading(false);
      return;
    }

    // ✅ Prevent upload if total would exceed 4
    const existingCount = formData.document?.length || 0;
    if (existingCount + validFiles.length > 4) {
      setErrors((prev) => ({
        ...prev,
        document: `You can only have up to 4 documents. You already have ${existingCount}.`,
      }));
      setUploadLoading(false);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${process.env.REACT_APP_URL}/upload`,
        formDataNew,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success) {
        setFormData((prev) => ({
          ...prev,
          document: [...(prev.document || []), ...response.data.data],
        }));

        setSnackbar({
          open: true,
          message: "Files Uploaded Successfully",
          severity: "success",
        });

        setErrors((prev) => ({ ...prev, document: "" }));
      }
    } catch (err) {
      console.error("Error uploading file", err);
      setErrors((prev) => ({
        ...prev,
        document: "Error while uploading file",
      }));
    } finally {
      setUploadLoading(false);
    }
  };

  const handleClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // const validateEmail = (email) => {
  //   const domain = email.split("@")[1];

  //   const re =
  //     /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) &&
  //     domain &&
  //     !restrictedDomains.some((restrictedDomain) =>
  //       domain.toLowerCase().includes(restrictedDomain)
  //     ) &&
  //     domain === userDomain;

  //   console.log(domain);
  //   console.log(userDomain);
  //   return re;
  // };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.campaignName)
      newErrors.campaignName = "Campaign Name is required";
    if (!formData.description)
      newErrors.description = "Description is required";

    if (!formData.emailAddress) {
      newErrors.emailAddress = "Email is Required";
    } else {
      const emailDomain = formData.emailAddress.split("@")[1];

      // Check if the email's domain matches the required domain
      if (!adminPortalView) {
        if (emailDomain !== userDomain) {
          newErrors.emailAddress = `Email domain must match the domain ${userDomain}`;
        }
      }
    }

    if (!formData.campaignOwnerName)
      newErrors.campaignOwnerName = "Campaign owner name is required";
    if (!formData.startDate) {
      newErrors.startDate = "Start Date is required";
    }
    if (!formData.endDate) {
      newErrors.endDate = "End Date is required";
    } else if (
      formData.startDate &&
      new Date(formData.endDate) < new Date(formData.startDate)
    ) {
      newErrors.endDate = "Please enter a valid End Date";
    }

    if (!formData.servicesNeeded) {
      newErrors.servicesNeeded = "Please select at least one service.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // const handleAddTeamMember = (e) => {
  //   if (["Enter", ",", " "].includes(e.key)) {
  //     e.preventDefault();
  //     const email = teamMember.trim();
  //     if (!email) return;

  //     if (!validateEmail(email)) {
  //       setteamError(true);
  //       setSnackbar({
  //         open: true,
  //         message:
  //           "Please enter an email address that matches your business domain",
  //         severity: "error",
  //       });
  //       return;
  //     }

  //     if (!formData.teamMembers.includes(email)) {
  //       setFormData((prev) => ({
  //         ...prev,
  //         teamMembers: [...prev.teamMembers, email],
  //       }));
  //     }
  //     setTeamMember("");
  //     setteamError(false);
  //   }
  // };

  const handleDeleteEmail = (member) => () => {
    setFormData((prev) => ({
      ...prev,
      teamMembers: prev.teamMembers.filter((m) => m !== member),
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log(name);

    setFormData((prevFormData) => {
      const updatedData = { ...prevFormData, [name]: value };

      // Validation logic for startDate
      if (name === "startDate") {
        setErrors((prev) => ({
          ...prev,
          startDate: !value, // If no value, set error to true
        }));

        // Check if endDate is earlier than startDate after updating startDate
        if (
          updatedData.endDate &&
          updatedData.endDate < updatedData.startDate
        ) {
          setErrors((prev) => ({
            ...prev,
            endDate: "Enter valid end Date", // Show error for invalid endDate
          }));
        } else {
          setErrors((prev) => ({ ...prev, endDate: false }));
        }
      }

      // Validation logic for endDate
      if (name === "endDate") {
        setErrors((prev) => ({
          ...prev,
          endDate:
            !value ||
            (prevFormData.startDate && value < prevFormData.startDate),
        }));

        // If endDate is earlier than startDate, set error
        if (prevFormData.startDate && value < prevFormData.startDate) {
          setErrors((prev) => ({ ...prev, endDate: "Enter a valid End Date" }));
        }
      }

      // Validation logic for campaignName
      if (name === "campaignName") {
        setErrors((prev) => ({
          ...prev,
          campaignName: !value, // If no value, set error to true
        }));
      }

      return updatedData;
    });
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleService = (challenge) => {
    setFormData((prevFormData) => {
      const updatedSelectedChallenges = prevFormData.servicesNeeded.includes(
        challenge
      )
        ? prevFormData.servicesNeeded.filter((item) => item !== challenge)
        : [...prevFormData.servicesNeeded, challenge];

      // Update the error state based on the new value of `servicesNeeded`
      setErrors((prevErrors) => ({
        ...prevErrors,
        servicesNeeded: updatedSelectedChallenges.length > 0 && false,
      }));

      return {
        ...prevFormData,
        servicesNeeded: updatedSelectedChallenges, // Properly update `servicesNeeded`
      };
    });
  };
  const handleDelete = async (e, id) => {
    Swal.fire({
      customClass: {
        container: "my-swal",
      },
      icon: "warning",
      text: "Do you want to delete this RFP Proposal?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.delete(
            `${serverURL}/requestForProposal/deleteRfp/${id}`,

            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );

          if (response.data.success === true) {
            // Show success message
            Swal.fire({
              customClass: {
                container: "my-swal",
              },
              icon: "success",
              text: response.data.message,
              padding: "1em",
              color: "black",
            }).then(() => {
              navigate("/user/RFP");
            });
          }
        } catch (error) {
          console.error("Error deleting client:", error);

          // Show error message if delete fails
          Swal.fire({
            customClass: {
              container: "my-swal",
            },
            icon: "error",
            text: error.response?.data?.message || "An error occurred",
            color: "black",
          });
        }
      }
    });
  };

  const handleRemoveDocument = (index) => {
    setFormData((prev) => ({
      ...prev,
      document: prev.document.filter((_, i) => i !== index),
    }));
  };

  const handleDeleteUpload = async () => {
    try {
      const response = await axios.post(
        `${serverURL}/deleteUpload`,
        { keys: formData.document },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (response.data.success === true) {
        Swal.fire({
          customClass: {
            container: "my-swal",
          },
          icon: "success",
          text: response.data.message,
          color: "black",
        });
        setFormData((prevFormData) => ({
          ...prevFormData,
          document: "",
        }));
      } else {
        Swal.fire({
          customClass: {
            container: "my-swal",
          },
          icon: "error",
          text: response.data.error,
          color: "black",
        });
      }
    } catch (error) {
      console.error("Error deleting upload:", error);
      Swal.fire({
        customClass: {
          container: "my-swal",
        },
        icon: "error",
        text: error,
        color: "black",
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Team Members Array -->", formData.teamMembers);
    if (!validateForm()) {
      Swal.fire({
        customClass: {
          container: "my-swal",
        },
        icon: "error",
        text:
          "Please fill out the required fields correctly" || errors.document,
        color: "black",
      });
    } else {
      // Update or create RFP
      try {
        // Check if we're updating an existing RFP
        if (selectedCampaign) {
          try {
            const response = await axios.put(
              `${serverURL}/requestForProposal/editRfp/${id}`,
              formData,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              }
            );

            if (response.status === 200) {
              Swal.fire({
                customClass: {
                  container: "my-swal",
                },
                icon: "success",
                text: "RFP updated successfully!",
                padding: "1em",
                color: "black",
              }).then(() => {
                navigate("/user/RFP");
              });
            }
          } catch (error) {
            console.error("Error updating RFP:", error);
            Swal.fire({
              customClass: {
                container: "my-swal",
              },
              icon: "error",
              title: error.response?.data?.message || "Update failed",
              padding: "1em",
            });
          }
        }
        // New rfp creation
        else {
          try {
            setIsLoading(true);
            const response = await axios.post(
              `${serverURL}/requestForProposal/addRfp`,
              formData,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              }
            );

            if (response.data.success === true) {
              Swal.fire({
                customClass: {
                  container: "my-swal",
                },
                icon: "success",
                text: response?.data?.message,
                padding: "1em",
                color: "black",
              }).then(() => {
                if (adminPortalView) {
                  setRfpGenerate(false);
                  navigate("/adminportal/Rfp");
                } else {
                  navigate("/user/RFP");
                }
              });
            } else {
              Swal.fire({
                customClass: {
                  container: "my-swal",
                },
                icon: "error",
                text: response.data.message || "Client not found",

                // text: "Error in creating organization",
              });
            }
          } catch (error) {
            Swal.fire({
              customClass: {
                container: "my-swal",
              },
              icon: "error",
              text: error.response?.data?.message,
              padding: "1em",
              color: "var(--heading-color)",
            });
          }
        }
      } catch (error) {
        console.error("Error creating or updating rfp:", error);
        setIsLoading(false);
        Swal.fire({
          customClass: {
            container: "my-swal",
          },
          icon: "error",
          title: error.response?.data?.message || "Operation failed",
          text: `Error in processing the organization details`,
          color: "black",
        });
      }
    }
  };
  const handleClose = () => {
    setRfpGenerate(false);
  };

  function capitalizeName(name) {
    if (!name) return name;

    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }

  return (
    <div
      className={`min-h-[670px] mb-8 flex items-center justify-center ml-0 md:ml-3 md:mb-3 relative ${
        adminPortalView ? "min-h-[750px]" : ""
      }`}
    >
      <Grid
        container
        className={`flex flex-col md:flex-row max-w-full absolute top-0 rounded-2xl gap-4 px-4 py-4 shadow-lg mb-20 bg-white overflow-auto ${
          adminPortalView ? "" : ""
        }`}
      >
        <div className="md:w-[60%]  px-2 ">
          <div>
            {id !== undefined ? (
              <h1 className="text-[20px]">
                {capitalizeName(formData?.campaignName)}
              </h1>
            ) : (
              <div>
                <h1 className="text-[20px]">GENERATE RFP</h1>
                <p className="text-[12px]">
                  {" "}
                  Start your campaign RFP from here -
                </p>
              </div>
            )}
          </div>
          <div className="mt-4 ">
            <Grid item xs={12} md={12} lg={12}>
              <label
                className={`text-[12px] font-[500] ${
                  errors.campaignName && "text-[var(--error-color)]"
                }`}
                style={{ marginBottom: "6px", display: "block" }}
              >
                Campaign Name *
              </label>
              <CustomInput
                className="text-xs font-medium leading-6 text-left"
                placeholder="Enter Campaign name"
                value={formData?.campaignName || ""}
                type="text"
                size="small"
                name="campaignName"
                customcolor="var(--heading-color)"
                fontWeight="500"
                onChange={(e) => {
                  if (!e.target.value.startsWith(" ")) {
                    handleInputChange(e);
                  }
                }}
                onBlur={(e) => {
                  if (saveButtonClicked) {
                    validateForm();
                  }
                }}
                error={errors?.campaignName}
                disabled={id !== undefined} // Disable if `id` is defined
              />
              {errors.campaignName && (
                <FormHelperText
                  className="text-[var(--error-color)] text-[12px] mt-3 ml-3"
                  sx={{
                    color: "var(--error-color)",
                    marginLeft: 1.5,
                  }}
                >
                  {errors?.campaignName}
                </FormHelperText>
              )}
            </Grid>

            <div className="flex flex-col justify-center md:flex-row mt-4  items-start gap-2  lg:gap-6">
              <Grid item xs={16} md={6} lg={6}>
                <label
                  className="text-[12px] font-[500]"
                  style={{ marginBottom: "6px", display: "block" }}
                >
                  Campaign Owner Email *
                </label>
                <CustomInput
                  className="text-xs font-medium leading-6 text-left"
                  placeholder="Enter your email"
                  type="email"
                  size="small"
                  name="emailAddress"
                  error={errors?.emailAddress}
                  value={
                    adminPortalView ? formData?.emailAddress : isEmail || ""
                  } // Reset value if adminPortalView is true
                  customcolor="var(--heading-color)"
                  fontWeight="500"
                  onChange={handleInputChange}
                  onBlur={() => {
                    if (saveButtonClicked) {
                      validateForm();
                    }
                  }}
                  disabled={!adminPortalView} // Enable input if adminPortalView is true
                />

                {errors.emailAddress && (
                  <FormHelperText
                    className="text-[var(--error-color)] text-[12px] -mt-3 ml-3"
                    sx={{
                      color: "var(--error-color)",
                      marginTop: -1,
                      marginLeft: 1.5,
                    }}
                  >
                    {errors?.emailAddress}
                  </FormHelperText>
                )}
              </Grid>

              <Grid item xs={12} md={6} lg={6}>
                <label
                  className="text-[12px] font-[500]"
                  style={{ marginBottom: "6px", display: "block" }}
                >
                  Campaign Owner Name *
                </label>

                <CustomInput
                  className="text-xs font-medium leading-6 text-left h-30 "
                  placeholder="Enter Owner Name"
                  // title="Campaign owner name*"
                  type="text"
                  size="small"
                  name="campaignOwnerName"
                  value={formData?.campaignOwnerName || ""}
                  customcolor="var(--heading-color)"
                  fontWeight="500"
                  error={errors.campaignOwnerName}
                  // errorMessage={errors.campaignOwnerName}
                  onChange={handleInputChange}
                  onBlur={() => {
                    if (saveButtonClicked) {
                      validateForm();
                    }
                  }}
                  disabled={!adminPortalView} // Enable input if adminPortalView is true
                />

                {errors?.campaignOwnerName && (
                  <FormHelperText
                    className="text-[var(--error-color)] text-[12px] -mt-3 ml-3"
                    sx={{
                      color: "var(--error-color)",
                      marginTop: -1,
                      marginLeft: 1.5,
                    }}
                  >
                    {errors?.campaignName}
                  </FormHelperText>
                )}
              </Grid>
            </div>
            <Grid item xs={12} md={12} lg={12}>
              <label
                className="text-[12px] font-[500]"
                style={{
                  marginBottom: "6px",
                  marginTop: "16px",
                  display: "block",
                }}
              >
                Campaign Owner Contact Number*
              </label>

              <CustomInput
                className="text-xs font-medium leading-6 text-left h-30 "
                placeholder="Enter Contact Number"
                type="tel" // Phone-specific input for mobile devices
                size="small"
                name="phoneNumber"
                value={
                  adminPortalView
                    ? formData?.campaignOwnerContactNumber
                    : isphoneNumber || ""
                }
                customcolor="var(--heading-color)"
                fontWeight="500"
                error={errors?.campaignOwnerContactNumber}
                onChange={(e) => {
                  // Restrict non-numeric characters and limit the length to 10 digits
                  const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                  if (value.length <= 10) {
                    // Only update if the length is <= 10
                    handleInputChange(e, value); // Pass the filtered value to handleInputChange
                  }
                }}
                onKeyPress={(e) => {
                  // Allow only numeric characters and prevent input if length is 10
                  if (
                    !/[0-9]/.test(e.key) ||
                    formData?.campaignOwnerContactNumber?.length >= 10
                  ) {
                    e.preventDefault(); // Prevent non-numeric key press or exceeding 10 digits
                  }
                }}
                onBlur={() => {
                  if (saveButtonClicked) {
                    validateForm();
                  }
                }}
                disabled={!adminPortalView} // Enable input if adminPortalView is true
              />
              {errors?.campaignOwnerContactNumber && (
                <FormHelperText
                  className="text-[var(--error-color)] text-[12px] -mt-3 ml-3"
                  sx={{
                    color: "var(--error-color)",
                    marginTop: -1,
                    marginLeft: 1.5,
                  }}
                >
                  {errors?.campaignOwnerContactNumber}
                </FormHelperText>
              )}
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <label
                className={`text-[12px] font-[500] ${
                  errors.description && "text-[var(--error-color)]"
                }`}
                style={{
                  marginBottom: "6px",
                  marginTop: "16px",
                  display: "block",
                }}
              >
                Description *
              </label>

              <TextField
                className="text-xs font-medium leading-6 text-left w-full"
                placeholder="Enter your description"
                title="Description"
                multiline
                type="text"
                value={formData?.description || ""}
                rows={8}
                size="small"
                name="description"
                disabled={id !== undefined}
                error={!!errors.description} // Add error prop
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": {
                      borderColor: errors.description
                        ? "var(--error-color)"
                        : "var(--listdown-color)",
                    },
                    "&:hover fieldset": {
                      borderColor: errors.description
                        ? "var(--error-color)"
                        : "var(--listdown-color)",
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: errors.description
                        ? "var(--error-color)"
                        : "var(--primary-color)",
                    },
                  },
                }}
                onChange={handleInputChange}
                onBlur={() => {
                  if (saveButtonClicked) {
                    validateForm();
                  }
                }}
              />
              {errors.description && (
                <FormHelperText
                  className="text-[var(--error-color)] text-[12px] mt-1 ml-3"
                  sx={{
                    color: "var(--error-color)",
                    marginLeft: 1.5,
                  }}
                >
                  {errors.description}
                </FormHelperText>
              )}
            </Grid>

            <div className="flex  lg:flex-row w-full gap-4 mb-3 mt-4">
              <Grid item xs={12} md={8} lg={10}>
                <div className="flex flex-col">
                  <label
                    className={`text-[12px] font-[500] ${
                      errors.startDate && "text-[var(--error-color)]"
                    }`}
                    style={{ marginBottom: "6px", display: "block" }}
                  >
                    Start Date *
                  </label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={
                        formData?.startDate ? dayjs(formData.startDate) : null
                      }
                      minDate={dayjs()} // Disable dates before today
                      onChange={(date) => {
                        handleInputChange({
                          target: { name: "startDate", value: date },
                        });
                      }}
                      format="DD/MM/YYYY" // Ensure consistent date format
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          error={errors.startDate} // Show error state
                          helperText={
                            errors.startDate &&
                            "Start date cannot be earlier than today"
                          }
                        />
                      )}
                      disabled={id !== undefined} // Disable if editing (id exists)
                    />
                  </LocalizationProvider>
                  {errors.startDate && (
                    <FormHelperText
                      className="text-[var(--error-color)] text-[12px] -mt-3 ml-3"
                      sx={{
                        color: "var(--error-color)",
                        marginTop: 1,
                        marginLeft: 1.5,
                      }}
                    >
                      Start date cannot be earlier than today
                    </FormHelperText>
                  )}
                </div>
              </Grid>

              <Grid item xs={12} md={8} lg={10}>
                <div className="flex flex-col">
                  <label
                    className={`text-[12px] font-[500] ${
                      errors?.endDate && "text-[var(--error-color)]"
                    }`}
                    style={{ marginBottom: "6px", display: "block" }}
                  >
                    End Date *
                  </label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      value={formData?.endDate ? dayjs(formData.endDate) : null}
                      minDate={
                        formData?.startDate ? dayjs(formData.startDate) : null
                      } // Must be ≥ start date
                      onChange={(date) => {
                        handleInputChange({
                          target: { name: "endDate", value: date },
                        });
                      }}
                      format="DD/MM/YYYY" // Same format as start date
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          fullWidth
                          error={errors.endDate} // Show error state
                          helperText={
                            errors.endDate &&
                            "End date cannot be earlier than start date"
                          }
                        />
                      )}
                      disabled={id !== undefined} // Disable if editing (id exists)
                    />
                  </LocalizationProvider>
                  {errors.endDate && (
                    <FormHelperText
                      className="text-[var(--error-color)] text-[12px] -mt-3 ml-3"
                      sx={{
                        color: "var(--error-color)",
                        marginTop: 1,
                        marginLeft: 1.5,
                      }}
                    >
                      {errors.endDate}
                    </FormHelperText>
                  )}
                </div>
              </Grid>
            </div>

            <div className="mb-2">
              <label
                className={`text-[12px] font-[500] ${
                  errors.servicesNeeded && "text-[var(--error-color)]"
                }`}
                style={{ marginBottom: "6px", display: "block" }}
              >
                Service needed*
              </label>

              <Stack direction="row" className="flex-wrap gap-2 mt-2">
                {SeriveNeeded?.map((challenge, index) => (
                  <Chip
                    // value={challengesInCurrentMarketing[challenge]}
                    key={index}
                    label={
                      <span className="flex justify-center items-center gap-2">
                        {challenge.icon && (
                          <span
                            style={{
                              marginRight: "2px",
                              verticalAlign: "middle",
                              color: formData.servicesNeeded.includes(
                                challenge.name
                              )
                                ? "#418cff" // Set the icon color to blue when selected
                                : "gray", // Gray when not selected
                            }}
                          >
                            {challenge?.icon}
                          </span>
                        )}
                        {challenge.name}
                      </span>
                    }
                    variant={
                      formData.servicesNeeded.includes(challenge.name)
                        ? "outlined"
                        : "outlined"
                    }
                    sx={{
                      cursor: "pointer",
                      backgroundColor: formData.servicesNeeded.includes(
                        challenge.name
                      )
                        ? "#e1ecff"
                        : "white",
                      borderColor: formData.servicesNeeded.includes(
                        challenge.name
                      )
                        ? "#418cff"
                        : "gray",
                      color: formData.servicesNeeded.includes(challenge.name)
                        ? "#418cff"
                        : "gray",
                      ...(!formData.servicesNeeded.includes(challenge.name) && {
                        "&:hover": operation
                          ? {}
                          : {
                              backgroundColor: "transparent",
                              color: "#418cff",
                              borderColor: "#418cff",
                            },
                      }),
                      ...(formData.servicesNeeded.includes(challenge.name) && {
                        "&:hover": {
                          backgroundColor: "#e1ecff",
                        },
                      }),
                    }}
                    onClick={(e) => {
                      if (!operation) {
                        handleService(e.target.innerText);
                      }
                    }}
                  />
                ))}
              </Stack>
              {errors.servicesNeeded && (
                <FormHelperText
                  className="text-[var(--error-color)] text-[12px] -mt-3 ml-3"
                  sx={{
                    color: "var(--error-color)",
                    marginTop: 1,
                    marginLeft: 1.5,
                  }}
                >
                  {errors.servicesNeeded}
                </FormHelperText>
              )}
            </div>
            <Grid item xs={12} md={12} lg={12}>
              {/* Label */}

              <label
                className="text-[12px] font-[500]"
                style={{
                  marginBottom: "6px",
                  marginTop: "4px",
                  display: "block",
                }}
              >
                Team
              </label>

              {/* Chips for Selected Team Members */}

              <div
                ref={containerRef}
                className="flex flex-wrap gap-2 max-h-16 overflow-auto items-center mb-3"
              >
                {formData?.teamMembers?.map((member) => (
                  <Chip
                    key={member.id}
                    label={member.emailAddress}
                    onDelete={
                      !operation
                        ? () => handleDeleteEmail(member.id)
                        : undefined
                    }
                    sx={{
                      cursor: operation ? "default" : "pointer",
                      backgroundColor: "var(--bg-color)",
                      color: "var(--label-color)",
                      borderRadius: "10px",
                    }}
                  />
                ))}
              </div>

              {/* Select Dropdown with Checkboxes */}
              {!operation && (
                <FormControl fullWidth size="small" error={errors.emailAddress}>
                  <Select
                    multiple
                    displayEmpty
                    value={formData?.teamMembers?.map((member) => member.id)} // Store selected IDs
                    onChange={(e) => {
                      const selectedIds = e.target.value; // Get selected IDs
                      const selectedMembers = team.filter((member) =>
                        selectedIds.includes(member._id)
                      ); // Find members by ID

                      setFormData((prev) => ({
                        ...prev,
                        teamMembers: selectedMembers.map((member) => ({
                          id: member._id,
                          emailAddress: member.emailAddress,
                        })),
                      }));
                    }}
                    renderValue={(selected) => {
                      if (!selected || selected.length === 0) {
                        return (
                          <span
                            className="text-[17px]"
                            style={{ color: "var(--listdown-color)" }}
                          >
                            Select Team Members
                          </span>
                        );
                      }
                      // Convert selected IDs to corresponding email addresses
                      const selectedEmails = formData.teamMembers
                        .filter((member) => selected.includes(member.id))
                        .map((member) => member.emailAddress);

                      return selectedEmails.join(", ");
                    }}
                    sx={{
                      color: formData?.teamMembers?.length
                        ? "var(--heading-color)"
                        : "var(--label-color)",
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(59, 130, 246, 1)",
                      },
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#b0b0b0",
                      },
                      "& .MuiOutlinedInput-root": {
                        "&:hover fieldset": { borderColor: "#b0b0b0" },
                      },
                    }}
                  >
                    {team?.map((member) => (
                      <MenuItem key={member._id} value={member._id}>
                        <Checkbox
                          checked={formData?.teamMembers?.some(
                            (m) => m.id === member._id
                          )}
                        />
                        {member.emailAddress || ""}
                      </MenuItem>
                    ))}
                  </Select>

                  {errors.emailAddress && (
                    <FormHelperText
                      className="text-[var(--error-color)] text-[12px] mt-3 ml-3"
                      sx={{
                        color: "var(--error-color)",
                        marginTop: 1,
                        marginLeft: 1.5,
                      }}
                    >
                      {errors?.emailAddress}
                    </FormHelperText>
                  )}
                </FormControl>
              )}
            </Grid>
          </div>
          <Snackbar
            open={snackbar.open}
            autoHideDuration={5000}
            onClose={handleSnackbarClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert
              onClose={handleSnackbarClose}
              severity={snackbar.severity} // Automatically includes the appropriate icon (success or error)
              sx={{
                backgroundColor:
                  snackbar.severity === "success" ? "green" : "black", // Green for success, red for error
                color: "white",
              }}
            >
              {snackbar.message}
            </Alert>
          </Snackbar>
          <div className="flex justify-between w-full mt-6">
            {/* Left Side (Empty for spacing) */}
            <div></div>

            {/* Right Side (Buttons) */}
            {/* <div className="flex gap-4">
              {id !== undefined && (
                <button
                  type="Submit"
                  className="text-[var(--error-color)] rounded-md font-semibold h-10 w-48"
                  style={{ border: "1px solid var(--error-color)" }}
                  onClick={(e) => handleDelete(e, SelectedCampaignDetails._id)}
                >
                  Delete Proposal
                </button>
              )}

              {id === undefined && (
                <CustomButton
                  type="Submit"
                  bgcolor="var(--primary-color)"
                  fontWeight="600"
                  className="h-10 w-48"
                  text={SelectedCampaignDetails ? "Save" : "Submit"}
                  onClick={(e) => {
                    setSaveButtonClicked(true);
                    handleSubmit(e);
                  }}
                />
              )}
            </div> */}
          </div>
        </div>

        {/* uploaded files */}
        <div className=" w-full  md:w-[35%] max-h-[446px]  ">
          {SelectedCampaignDetails ? (
            <p className="text-[var(--heading-color)] mb-3"> RFP</p>
          ) : (
            <div className="w-full flex justify-between items-center relative">
              <p
                className={` mb-3 ${
                  errors.document
                    ? "text-[var(--error-color)]"
                    : "text-[var(--heading-color)]"
                }`}
              >
                Upload RFP
              </p>
            </div>
          )}
          {!operation && (
            <div
              style={{
                border: "2px dashed var(--primary-color)",
                padding: "10px",
                borderRadius: "4px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                height: "100%",
              }}
              className="w-full bg-[var(--bg-color)] relative rounded-2xl"
            >
              <label className="relative">
                {uploadLoading ? (
                  <CircularProgress />
                ) : (
                  <div className="flex flex-col justify-center items-center w-full h-full cursor-pointer">
                    <UploadRfpIcon color={"var(--primary-color)"} size="70" />
                    <input
                      type="file"
                      ref={fileInputRef}
                      onClick={handleClick}
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                      accept=".pdf,.doc,.xls,.xlsx,.png,.jpg,.jpeg,.docx"
                      multiple
                    />
                    <span
                      style={{
                        marginTop: "10px",
                        color: "var(--primary-color)",
                        textAlign: "center",
                      }}
                    >
                      Upload your RFP here in .pdf, .doc, .xls, .png, .jpeg
                      format or browse (max size: 2MB)
                    </span>
                  </div>
                )}
              </label>
              {errors.document && (
                <FormHelperText
                  className="text-[var(--error-color)] text-[12px] mt-2 ml-3"
                  sx={{
                    color: "var(--error-color)",
                    marginTop: 2,
                    marginLeft: 1.5,
                  }}
                >
                  {errors.document}
                </FormHelperText>
              )}
            </div>
          )}

          <p className="mt-3">Uploaded Documents :</p>

          <div
            style={{
              border: "2px dashed var(--para-color)",
              padding: "10px",
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              flexDirection: "row",
              height: "40%",
              overflowX: "auto",
              whiteSpace: "nowrap",
            }}
            className="w-full bg-gray-200 relative rounded-2xl mt-4"
          >
            {formData?.document && formData?.document?.length > 0 ? (
              formData?.document?.map((doc, index) => {
                const fileExtension = doc.split(".").pop().toLowerCase(); // Extract extension from URL

                return (
                  <div
                    key={index}
                    style={{
                      minWidth: "150px",
                      marginRight: "10px",
                      padding: "6px 12px",
                      backgroundColor: "#fff",
                      borderRadius: "6px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                      cursor: "pointer",
                      position: "relative",
                    }}
                  >
                    {!operation && (
                      <IconButton
                        size="small"
                        onClick={() => handleRemoveDocument(index)}
                        style={{
                          position: "absolute",
                          top: "4px",
                          right: "4px",
                          backgroundColor: "rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    )}

                    {fileExtension === "pdf" ? (
                      <iframe
                        src={doc.url || doc}
                        width="150"
                        height="100"
                        style={{
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          overflow: "hidden",
                        }}
                      />
                    ) : fileExtension === "xls" || fileExtension === "xlsx" ? (
                      <div
                        style={{
                          width: "80px",
                          height: "80px",
                          backgroundColor: "#f0f0f0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "14px",
                          fontWeight: "bold",
                        }}
                      >
                        📊 Excel
                      </div>
                    ) : fileExtension === "jpeg" ||
                      fileExtension === "jpg" ||
                      fileExtension === "png" ? (
                      <img
                        src={doc.url || doc}
                        style={{
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                          overflow: "hidden",
                          objectFit: "contain",
                          height: "120px",
                          width: "80px",
                        }}
                      />
                    ) : (
                      <span
                        style={{
                          fontSize: "14px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          maxWidth: "100px",
                        }}
                        title={doc.name || doc}
                      >
                        {doc.name || doc}
                      </span>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="w-full h-full flex justify-center items-center">
                <p style={{ color: "var(--label-color)", fontSize: "14px" }}>
                  No Documents Uploaded.
                </p>
              </div>
            )}
          </div>
        </div>

        {/* button */}
        {!operation && (
          <Grid item xs={12} className="text-right">
            <div className="block mt-8 text-center">
              <CustomButton
                // type="Submit"
                // isLoading={isLoading}
                color="var(--heading-color)"
                fontWeight="600"
                className="h-10 w-48 "
                text={SelectedCampaignDetails ? "Save" : "Submit"}
                onClick={(e) => {
                  // setIsLoading(true)
                  setSaveButtonClicked(true);
                  handleSubmit(e);
                }}
              />
            </div>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default ClientRFPModal;
